import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { EmergencyType } from './emergencyType.model';

const axios = useAxios();

export interface EmergencyTypeService {
  Fetch: () => Promise<AxiosResponse<EmergencyType[]>>;
}

const Fetch = (): Promise<AxiosResponse<EmergencyType[]>> => axios.Get<EmergencyType[]>('/api/emergencytypes');

export default { Fetch } as EmergencyTypeService;
